import { Component } from '@angular/core';

@Component({
  selector: 'app-jedinstveni-pozivi-report',
  templateUrl: './jedinstveni-pozivi-report.component.html',
  styleUrls: ['./jedinstveni-pozivi-report.component.scss'],
})
export class JedinstveniPoziviReportComponent {}
